import React, { memo } from "react";
import { areFilterPropsEqual, CustomStyleDynamicWidth } from "../helper";
import Select from "react-select";
import styles from "../styles.module.scss";
import { useTranslation } from "react-i18next";
import { cls } from "app/utils";

const SelectFilter = ({
  title,
  options,
  isClearable,
  value,
  queryName,
  onChange,
}) => {
  const { t } = useTranslation();

  const setQueryValue = (selection) => {
    selection === null
      ? onChange({
          [queryName]: null,
        })
      : onChange({
          [queryName]: selection?.value,
        });
  };

  return (
    <div className={cls(styles.filter_container, styles.w_full)}>
      <div className={styles.title}>{title}</div>
      <Select
        options={options}
        styles={CustomStyleDynamicWidth}
        placeholder={t("Select")}
        isClearable={isClearable}
        value={options.find((el) => String(el.value) === String(value)) || null}
        components={{
          IndicatorSeparator: () => null,
        }}
        onChange={setQueryValue}
      />
    </div>
  );
};

export default memo(SelectFilter, areFilterPropsEqual);
